/**
 * stageDisplay.js
 *
 * Single source of truth for how internal stage/status names
 * are shown to the user across all UI components.
 *
 * Keys must be LOWERCASE so matching is case-insensitive.
 */
export const STAGE_DISPLAY_MAP = {
    "requested": "New",
};

/**
 * Returns the user-facing label for a stage/status name.
 * Falls back to the original value if no mapping is found.
 *
 * @param {string|null|undefined} rawName - The internal stage name
 * @returns {string}
 */
export const getStageDisplayName = (rawName) => {
    if (!rawName || typeof rawName !== "string") return rawName ?? "";
    return STAGE_DISPLAY_MAP[rawName.toLowerCase().trim()] ?? rawName;
};
